import axios from 'axios';

export const getStudentReportDetails = (studentId) => {
	return axios.get(`/api/v2/incident/filters/${studentId}`);
};

export const createIncidentReport = (data) => {
	return axios.post('/api/v2/incident', data);
};

export const getIncidentReports = (filters = {}) => {
	const defaultFilters = {
		page: 1,
		status: '',
		student_id: [],
		room_id: [],
		...filters,
	};

	return axios.get('/api/v2/incident', {
		params: defaultFilters,
	});
};

export const updateIncidentReportStatus = (incidentId, status) => {
	return axios.patch(`/api/v2/incident/${incidentId}/status`, {
		status,
	});
};

export const bulkResolveIncidents = async (data) => {
	return axios.post('/api/v2/incident/bulk/status', data);
};

export const bulkDeleteIncidents = async (data) => {
	return axios.delete('/api/v2/incident/bulk', { data });
};

export const deleteIncidentReport = async (incidentId) => {
	return axios.delete(`/api/v2/incident/${incidentId}`);
};

export const getIncidentReportDetails = async (incidentId) => {
	return axios.get(`/api/v2/incident/${incidentId}`);
};

export const updateIncidentReport = async (incidentId, data) => {
	return axios.put(`/api/v2/incident/${incidentId}`, data);
};

export const getIncidentReportPdF = async (incidentId, params = {}) => {
	return axios.post(`/api/v2/incident/${incidentId}/export`, params);
};
